// Check if a string is alphanumeric w/ special char (, - .), and optionally check length with minLength and maxLength

export const isAlphanumeric = (stringToCheck: string, minLength?: number, maxLength?: number): boolean => {
  let regex = /^[a-zA-Z0-9À-ỹ ,-.&"']+$/;
  if (minLength || maxLength) {
    regex = new RegExp(`^[a-zA-Z0-9À-ỹ ,-.&"']{${minLength || 0},${maxLength || ''}}$`);
  }
  return regex.test(stringToCheck);
};
